'use client'
import { Flex, Text } from '@mantine/core'
import { useParams } from 'next/navigation'
import { useTranslations } from 'next-intl'

import { getMarketBreadcrumbHref } from '@/app/[locale]/price/_components/HomepageV2/breadcrumbMarket'
import ChevronRight from '@/assets/icons/chevron-right.svg'
import { I18nLink } from '@/i18n/navigation'

import { useStockContext } from '../_contexts/StockContext'

export default function StockDetailHeader() {
  const { stock } = useStockContext()
  const t = useTranslations('common')
  const { locale } = useParams<{ locale: string }>()

  return (
    <Flex align={'center'} mb={32}>
      {/* WWW-5191: US region 下跳到首页 stocks tab，避免落到默认的 predictions */}
      <I18nLink href={getMarketBreadcrumbHref(locale, 'stocks')} prefetch={true}>
        <Text c={'var(--content-secondary)'} variant={'subtitle'}>
          {t('Market')}
        </Text>
      </I18nLink>
      <ChevronRight height={16} fill={'var(--content-tertiary)'} />
      <Text variant={'subtitle'} c={'var(--content-primary)'}>
        {stock.name}
      </Text>
    </Flex>
  )
}
